{
  "SitePageTemplateSettings": {
    "ActionMenuLabel": "Tillgängliga åtgärder"
  },
  "components": {
    "AppLanguageSelector": {
      "toggleLanguageSwitcher": "Öppna/stäng språkmenyn"
    },
    "BannerTitle": {
      "BannerBlockTitleAlignmentSelector": {
        "ActionMenuLabel": "Välj textjustering"
      },
      "BannerBlockTitleSizeSelector": {
        "ActionMenuLabel": "Välj textstorlek"
      },
      "BannerBlockTitleTransformationSelector": {
        "ActionMenuLabel": "Välj texttransformation"
      },
      "BannerBlockTitleVerticalAlignmentSelector": {
        "ActionMenuLabel": "Välj vertikal textjustering"
      },
      "BannerBlockTitleWeightSelector": {
        "ActionMenuLabel": "Välj teckentjocklek"
      }
    },
    "CardEditor": {
      "Category": "Välj kategori",
      "Skin": "Välj färg"
    },
    "CommonBlockContent": {
      "Alignment": {
        "ActionMenuLabel": "Välj textjustering"
      }
    },
    "EditorBreadcrumbs": {
      "Description": "Den fullständiga sökvägen till den här sidan"
    },
    "EditorHeader": {
      "CreatePage": "Skapa ny sida",
      "GoBack": "Gå tillbaka"
    },
    "EditorPreviewContainer": {
      "AdditionalActions": "Ytterligare åtgärder för förhandsgranskning",
      "SelectDeviceType": "Välj enhetstyp för förhandsgranskning"
    },
    "EditorSectionActionButton": {
      "ActionMenuLabel": "Tillgängliga åtgärder"
    },
    "EditorView": {
      "Tabs": "Kategorier av innehåll du kan redigera"
    },
    "FilterMenu": {
      "MenuLabel": "Ändra vilka sidor som ska visas"
    },
    "FinderLayout": {
      "CloseFinder": "Stäng sökaren",
      "ToggleFiltersOpen": "Öppna/stäng filteravsnitt"
    },
    "Header": {
      "navigateToHome": "Gå till startsidan",
      "toggleMenuButton": "Öppna/stäng menyn"
    },
    "ListView": {
      "AddRemoveAsFavourite": "Lägg till/ta bort från favoriter",
      "SelectOrDeselect": "Markera eller avmarkera objekt"
    },
    "MainLayout": {
      "ToggleMenu": "Expandera/komprimera menyn"
    },
    "PageBlockArticleTitleBlockTextAlignSetting": {
      "ActionMenuLabel": "Välj textjustering"
    },
    "PageBlockBannerLayoutSetting": {
      "ActionMenuLabel": "Välj layout"
    },
    "PageBlockBannerSizeSetting": {
      "ActionMenuLabel": "Välj storlek"
    },
    "PageBlockCardModuleViewSetting": {
      "ActionMenuLabel": "Välj visningstyp"
    },
    "PageBlockCollapsibleStateSetting": {
      "ActionMenuLabel": "Välj kollapstillstånd"
    },
    "PageBlockLayoutSetting": {
      "ActionMenuLabel": "Välj layout"
    },
    "PageBlockLinkListViewSetting": {
      "ActionMenuLabel": "Välj visningstyp"
    },
    "PageBlockModuleLayoutSetting": {
      "ActionMenuLabel": "Välj modullayout"
    },
    "PageBlockModuleTypeSetting": {
      "ActionMenuLabel": "Välj modultyp"
    },
    "PageBlockPageListLayoutSetting": {
      "ActionMenuLabel": "Välj layout"
    },
    "PageBlockPositionSetting": {
      "ActionMenuLabel": "Välj position"
    },
    "PageBlockTextPositionSetting": {
      "ActionMenuLabel": "Välj textjustering"
    },
    "PageBlockTextSizeSetting": {
      "ActionMenuLabel": "Välj textstorlek"
    },
    "PageTree": {
      "ImportedPageTreeDescription": "Hierarki över importerade sidor på {{siteName}}-webbplatsen som väntar på placering",
      "PageTreeDescription": "Hierarki över alla sidor på {{siteName}}-webbplatsen"
    },
    "PageTreeActionMenu": {
      "MenuDescription": "Tillgängliga åtgärder för sidan \"{{pageName}}\""
    },
    "PageTreeFilter": {
      "ClearAllFilters": "Rensa alla filter",
      "ClearQuery": "Rensa sökning"
    },
    "SearchSelector": {
      "SearchFieldLabel": "Sök"
    },
    "SectionDirectionSelector": {
      "ActionMenuLabel": "Välj riktning på avsnittets innehåll"
    },
    "SectionDraggingPlaceholder": {
      "Label": "Detta är en platshållare för avsnittet som flyttas"
    },
    "SectionDropIndicator": {
      "Label": "Detta anger var avsnittet kommer att placeras"
    },
    "SectionWidthSelector": {
      "ActionMenuLabel": "Välj bredd på avsnittet"
    },
    "SideMenuLayout": {
      "closeMenuButton": "Stäng menyn"
    },
    "SkinSelector": {
      "SelectSkinTooltip": "Välj skinn"
    },
    "SortMenu": {
      "MenuLabel": "Välj hur sidor sorteras"
    },
    "SplitButton": {
      "ShowAllOptions": "Visa alla alternativ"
    },
    "UserAvatarMenu": {
      "toggleUserMenu": "Öppna/stäng användarmenyn"
    }
  },
  "preview": {
    "PreviewWrapper": {
      "ToggleDeveloperPreview": "Växla utvecklarförhandsgranskning"
    }
  }
}
